import { render, staticRenderFns } from "./ModalGeneral.vue?vue&type=template&id=04c5a793&"
import script from "./ModalGeneral.vue?vue&type=script&lang=js&"
export * from "./ModalGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports